import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ElectricMobilityWidget } from "@edp-models/electric-mobility.model";
import { SetActiveTab } from "@edp-store/actions/consumption.actions";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { getElectricMobilityWidget } from "@edp-store/selectors/dashboard.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";

@Component({
    selector: "edp-widget-mobility",
    templateUrl: "./edp-widget-mobility.component.html",
    styleUrls: ["./edp-widget-mobility.component.scss"],
})
export class EdpWidgetMobilityComponent {
    mockValue = "306,85";
    electricMobility$: Observable<ElectricMobilityWidget>;

    constructor(private readonly router: Router, private readonly store: Store<IAppState>) {
        this.electricMobility$ = this.store.pipe(select(getElectricMobilityWidget));
    }

    goToMobilityPage() {
        this.store.dispatch(new SetActiveTab("M"));
        this.store
            .pipe(take(1), select(getContract))
            .subscribe(contract => this.router.navigateByUrl(`energia/${contract.ContractId}/consumos`));
    }
}
